import React, { useState } from 'react';
import HGBarcodeScanner from 'components/HGBarcodeScanner';
import HGFormInput from 'components/HGForm/HGFormInput';
import { Button } from 'components/shadcn/ui/button';
import { Scan } from 'lucide-react';

const SerialNumberInput = (props) => {
    const [barcodeScannerOpen, setBarcodeScannerOpen] = useState(false);
    return (
        <div className="w-full">
            <HGFormInput
                type="text"
                placeholder="Serial Number"
                endAdornment={
                    <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        className="h-6 w-6 p-0"
                        onClick={() => setBarcodeScannerOpen(true)}
                    >
                        <Scan className="h-4 w-4" />
                    </Button>
                }
                {...props}
            />
            <HGBarcodeScanner
                modalOpen={barcodeScannerOpen}
                handleClose={() => setBarcodeScannerOpen(false)}
                fieldName="serialNumber"
            />
        </div>
    );
};

export default SerialNumberInput;
